import { Component, NgZone, AfterViewInit, ViewChild, ElementRef } from '@angular/core';

import { AlertController, NavController } from 'ionic-angular';

import { LoginPage } from '../login/login';
import { KontrollenCreatePage } from '../kontrollen/kontrollen-create';
import { AdminPage } from '../admin/admin';
import { UserData } from '../../providers/user-data';
import { ParplatzData } from '../../providers/pp-data';
import { UEData } from '../../providers/ue-data';
import { EinsatzplanData } from '../../providers/einsatzplan-data';
import { Platform } from 'ionic-angular';
import { PPListPage } from '../pp-list/pp-list';
import { NotificationData } from '../../providers/notification-data';
import { NotificationListPage } from '../notifications/notification-list';
import { CommonData } from '../../providers/common-data';
import { LogperiodicjobsData } from '../../providers/logperiodicjobs-data';

import { Geolocation } from '@ionic-native/geolocation';
import { InAppBrowser } from '@ionic-native/in-app-browser';

import 'rxjs/add/operator/map';
declare var google; // Added
@Component({
  selector: 'account-home',
  templateUrl: 'account-home.html'
})
export class AccountHomePage {
  @ViewChild('map') mapElement: ElementRef; // Added
  data: any;
  strUECount : string;
  oEPToday: any;
  iNewMessage: number = 0;
  map: any;
  selectedPPName: string;
  zone: NgZone;

  navigationURL: string;

  showcard: boolean = false;

  selectedmarker: any;
  previousmarkercolor: any;

  //@ViewChild('ppmaphome') PpmapComponent;  
  
  constructor(
            public alertCtrl: AlertController
          , public navCtrl: NavController
          , public userData: UserData
          , public ueData: UEData
          , public epData: EinsatzplanData
          , public ppData: ParplatzData
          , public notificationData: NotificationData
          , public platform:Platform
          , public common: CommonData
          , public geolocation: Geolocation
          , private iab: InAppBrowser
          , private lpj: LogperiodicjobsData

          ) {
            this.strUECount= "0";
            this.oEPToday = {};
            this.selectedPPName = "Init";
            this.zone = new NgZone({ enableLongStackTrace: false });
            this.navigationURL = "";
      Promise.all([               
          this.notificationData.load(),          
        ]).then(data => {
          //let m = data[1] as Array<any>;
          //console.log(m.length);
          //this.iNewMessage = m.length;
          
          this.oEPToday = this.epData.getToday();
          this.oEPToday.then(data =>{
            //console.log(this.epData.datatoday);
            //console.log("ep geladen");

          })
        });                
  }
  ngAfterViewInit() {
    // Now you can use the tabs reference
    //console.log("a = ", this.ppmap);
  }

  onStartKontByPPName(ppShortname){
    this.selectedPPName = ppShortname;
    this.startKontrolle();    
  }

  startKontrolle(){
    //console.log("test");
    this.platform.ready().then(() => {
      this.geolocation.getCurrentPosition({enableHighAccuracy:true}).then((position) => {
        this.userData.actposition = position;        

        if((this.userData.usergroup_id==1 || this.userData.usergroup_id==2) && this.platform.is('cordova')){
          let pp = this.ppData.ppbyshortname(this.selectedPPName);
          //console.log(pp);
          if(pp != null){
            this.navCtrl.setRoot(KontrollenCreatePage, {pp:pp,actlat: this.userData.actposition.coords.latitude, actlng:this.userData.actposition.coords.longitude});    
          }  
        }
            
      }, (err) => {
        console.log(err);
      });    
    });        
  }

  navigateLogPeriodic(){
    this.navCtrl.setRoot(AdminPage);
  }

  ionViewDidEnter(){
    if((this.userData.usergroup_id == 1)){
      this.lpj.clear();
      this.lpj.load();
  
    }
  }
  initMap() {
    this.navigationURL = "";

    this.platform.ready().then(() => {

      this.geolocation.getCurrentPosition({enableHighAccuracy:true}).then((position) => {
        this.userData.actposition = position;
        //console.log(position.coords.latitude);

        let actpos = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
        let mapcenter = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
        let mapOptions = {          
          center: mapcenter,
          zoom: 14,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          disableDefaultUI: true
        }

        if(this.mapElement && this.mapElement.nativeElement){
          this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);   

          this.addMarker(position.coords.latitude,position.coords.longitude,"Aktuelle Position", "", "./assets/img/location_point_red.png", 30, 30);
          
          this.loadPPsToMap();
  
        }

      });        
    }, (err) => {
        console.error(err);
    });    

    }

    loadPPsToMap(){
      this.navigationURL = "";
      this.geolocation.getCurrentPosition({enableHighAccuracy:true}).then((position) => {
        this.userData.actposition = position;
        let actpos = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
        let nearestpp: any;
        let nearesppdistance:number;
        nearesppdistance = 10000;       
        //-- loop mandate ------
        for(let i=0; i<this.epData.datatoday.length; i++){
          //-- loop mandate ------
          for(let m=0; m<this.epData.datatoday[i].mandate.length; m++){
            //-- loop pp ------
            //console.log(m);
            for(let p=0; p<this.epData.datatoday[i].mandate[m].pp.length; p++){
              //console.log(p);
              let pp = this.epData.datatoday[i].mandate[m].pp[p];
              //console.log(pp);
              let pppos = new google.maps.LatLng(pp.latit, pp.longit);              
              let dist = this.common.getDistanceFromLatLonInKM(position.coords.latitude, position.coords.longitude, pp.latit, pp.longit);

              pp.distance = dist;
              
              if(pp.distance < nearesppdistance){
                nearestpp = pp;
                nearesppdistance = pp.distance;
              }
              let markercolor = "./assets/img/marker_px.png";                 
  
              if(pp.status == "durchgeführt"){
                //markercolor = "#32db64";
                markercolor = "./assets/img/marker_check.png";
              }
  
              this.addMarker(pp.latit,pp.longit,pp.kurzname, this.epData.datatoday[i].mandate[m].mandat, markercolor);           
                  
              }
              
          }
        }

        if(nearesppdistance < 0.1){
          this.zone.run(() => {
            this.selectedPPName = nearestpp.kurzname;
          });                                      
        }        
        
      });        

    }

    test(){
      this.showcard = !this.showcard;
      this.initMap();
    }
    addMarker(latit, longit, kurzname, mandat, iconurl, markerwidth?:number, markerheight?:number) { // To Add Marker
      if(!markerwidth){
        markerwidth = 29.8;
      }
      if(!markerheight){
        markerheight = 50;
      }

      let latLng = new google.maps.LatLng(latit, longit);

      var image = {
        url: iconurl,
        // This marker is 20 pixels wide by 32 pixels high.
        scaledSize: new google.maps.Size(markerwidth, markerheight),
        // The origin for this image is (0, 0).
        origin: new google.maps.Point(0, 0),
        // The anchor for this image is the base of the flagpole at (0, 32).
        anchor: new google.maps.Point(0, markerheight)
      };

      let marker = new google.maps.Marker({
        title: kurzname,
        map: this.map,
        animation: google.maps.Animation.DROP,
        position: latLng,
        icon: image          
      });
      //marker.addListener('click', toggleBounce);
      let content = "<h3>"+kurzname+"</h3><h4>"+mandat+"</h4>";
      this.addInfoWindow(marker, content);
    }
    /*
    toggleBounce() {
      if (marker.getAnimation() !== null) {
        marker.setAnimation(null);
      } else {
        marker.setAnimation(google.maps.Animation.BOUNCE);
      }
    }
    */
   
    addInfoWindow(marker, content) {
      let infoWindow = new google.maps.InfoWindow({
        content: content
      });
      google.maps.event.addListener(marker, 'click', () => {

        //-- Reset previously selected Marker --------
        if(this.selectedmarker){
          this.selectedmarker.setIcon(this.previousmarkercolor);
        }         
        
        this.selectedmarker = marker;
        this.previousmarkercolor = marker.getIcon();

        let iconurl = "./assets/img/marker_px_red.png";        
        let markerwidth = 29.8;
        let markerheight = 50;
        
        var image = {
          url: iconurl,
          // This marker is 20 pixels wide by 32 pixels high.
          scaledSize: new google.maps.Size(markerwidth, markerheight),
          // The origin for this image is (0, 0).
          origin: new google.maps.Point(0, 0),
          // The anchor for this image is the base of the flagpole at (0, 32).
          anchor: new google.maps.Point(0, markerheight)
        };        
        marker.setIcon(image);
        /*
        if (marker.getAnimation() !== null) {
          marker.setAnimation(null);
        } else {
          marker.setAnimation(google.maps.Animation.BOUNCE);
        }
        */        

        this.navigationURL = "https://www.google.com/maps/dir/?api=1&destination="+marker.getPosition().lat()+","+marker.getPosition().lng()+"&travelmode=driving";
        if(this.userData.actposition){
          this.navigationURL = this.navigationURL+"&origin="+this.userData.actposition.coords.latitude+","+this.userData.actposition.coords.longitude;
        }
        this.selectedPPName = marker.getTitle();
        //infoWindow.open(this.map, marker);
        
      });
    }
    navigateToPP(){
      const browser = this.iab.create(this.navigationURL, '_system');      
      console.log(this.navigationURL);
    }          
  loadMapold(){
    /*
    this.platform.ready().then(() => {
      this.geolocation.getCurrentPosition({enableHighAccuracy:true}).then((position) => {
        this.userData.actposition = position;        
    
        // Wait the maps plugin is ready until the MAP_READY event
        this.map.one(GoogleMapsEvent.MAP_READY).then(() => {
          let location =  new google.maps.LatLng(this.userData.actposition.coords.latitude, this.userData.actposition.coords.longitude);
            // Move the map camera to the location with animation
            console.log(location);
            return this.map.animateCamera({
              target: location,
              zoom: 14,
              tilt: 30,
              duration:200
            }).then(() => {
              this.map.addMarker({
                title: "Aktuelle Position",
                icon: {
                  url: "./assets/img/location_point_red.png",
                  size: {
                      width: 25,
                      height: 25
                   }
                 },                  
                position: location,
                animation: GoogleMapsAnimation.DROP
              });
                let nearestpp: any;
                let nearesppdistance:number;
                nearesppdistance = 10000;
                //-- loop mandate ------
                for(let i=0; i<this.epData.datatoday.length; i++){
    
                  //-- loop mandate ------
                  for(let m=0; m<this.epData.datatoday[i].mandate.length; m++){
                    //-- loop pp ------
                    //console.log(m);
                    for(let p=0; p<this.epData.datatoday[i].mandate[m].pp.length; p++){
                      //console.log(p);
                      let pp = this.epData.datatoday[i].mandate[m].pp[p];
                      //console.log(pp);
                      let pppos = new google.maps.LatLng(pp.latit, pp.longit);              
                      let dist = this.common.getDistanceFromLatLonInKM(this.userData.actposition.coords.latitude, this.userData.actposition.coords.longitude, pp.latit, pp.longit);
                      pp.distance = dist;
                      if(pp.distance < nearesppdistance){
                        nearestpp = pp;
                        nearesppdistance = pp.distance;
                      }
                      let markercolor = "./assets/img/marker_px.png";                 
    
                      if(pp.status == "durchgeführt"){
                        //markercolor = "#32db64";
                        markercolor = "./assets/img/marker_check.png";
                      }
                        this.map.addMarker({
                          title: pp.kurzname,
                          icon: {
                            url: markercolor,
                            size: {
                                width: 29.8,
                                height: 50
                             }
                           },                  
                          snippet: pp.mandat+ "("+ pp.distance.toFixed(3)+ " km entfernt)",
                          position: pppos,
                          animation: GoogleMapsAnimation.DROP
                        }).then(
                          (marker: Marker) => {
                                  marker.addEventListener(GoogleMapsEvent.MARKER_CLICK).subscribe(
                                      (data) => {
                                          this.zone.run(() => {
                                            //console.log("hallo");
                                            this.selectedPPName = marker.getTitle();
                                          });                                      
                                      }
                                  );
                           }
                      );
                          
                      }
                      
                  }
                }
                if(nearesppdistance < 0.1){
                  this.zone.run(() => {
                    this.selectedPPName = nearestpp.kurzname;
                  });                                      
                }
    
            })

              
        });        
      }, (err) => {
        console.log(err);
      });    
    });    
    */
  }
  reloadMap(){
    this.epData.getToday().then((data:any) => {
      this.initMap();
    });
    /*
      this.geolocation.getCurrentPosition({enableHighAccuracy:true}).then((position) => {
        this.userData.actposition = position;        
    
        // Wait the maps plugin is ready until the MAP_READY event
        

          console.log("this.userData.actposition.coords");
          console.log(this.userData.actposition.coords);
          
          this.map.clear();
          let location =  new google.maps.LatLng(this.userData.actposition.coords.latitude, this.userData.actposition.coords.longitude);
            // Move the map camera to the location with animation
            console.log(location);
            
            this.map.animateCamera({
              target: location,
              //zoom: 14,
              tilt: 30,
              duration:200
            }).then(() => {
              this.map.addMarker({
                title: "Aktuelle Position",
                icon: {
                  url: "./assets/img/location_point_red.png",
                  size: {
                      width: 25,
                      height: 25
                   }
                 },                  
                position: location,
                animation: GoogleMapsAnimation.DROP
              });
                let nearestpp: any;
                let nearesppdistance:number;
                nearesppdistance = 10000;
                //-- loop mandate ------
                for(let i=0; i<this.epData.datatoday.length; i++){
    
                  //-- loop mandate ------
                  for(let m=0; m<this.epData.datatoday[i].mandate.length; m++){
                    //-- loop pp ------
                    //console.log(m);
                    for(let p=0; p<this.epData.datatoday[i].mandate[m].pp.length; p++){
                      //console.log(p);
                      let pp = this.epData.datatoday[i].mandate[m].pp[p];
                      //console.log(pp);
                      let pppos = new google.maps.LatLng(pp.latit, pp.longit);              
                      let dist = this.common.getDistanceFromLatLonInKM(this.userData.actposition.coords.latitude, this.userData.actposition.coords.longitude, pp.latit, pp.longit);
                      pp.distance = dist;
                      if(pp.distance < nearesppdistance){
                        nearestpp = pp;
                        nearesppdistance = pp.distance;
                      }
                      let markercolor = "./assets/img/marker_px.png";                 
    
                      if(pp.status == "durchgeführt"){
                        //markercolor = "#32db64";
                        markercolor = "./assets/img/marker_check.png";
                      }
                        this.map.addMarker({
                          title: pp.kurzname,
                          icon: {
                            url: markercolor,
                            size: {
                                width: 29.8,
                                height: 50
                             }
                           },                  
                          snippet: pp.mandat+ "("+ pp.distance.toFixed(3)+ " km entfernt)",
                          position: pppos,
                          animation: GoogleMapsAnimation.DROP
                        }).then(
                          (marker: Marker) => {
                                  marker.addEventListener(GoogleMapsEvent.MARKER_CLICK).subscribe(
                                      (data) => {
                                          this.zone.run(() => {
                                            //console.log("hallo");
                                            this.selectedPPName = marker.getTitle();
                                          });                                      
                                      }
                                  );
                           }
                      );
                          
                      }
                      
                  }
                }
                if(nearesppdistance < 0.1){
                  this.zone.run(() => {
                    this.selectedPPName = nearestpp.kurzname;
                  });                                      
    }
    
            })
             
           
      }, (err) => {
        console.log(err);
      });    
  */
  }


  ionViewWillEnter() {
    this.doSearch();
      Promise.all([    
          this.epData.getToday(),            
        ]).then(data => {
          //console.log("data today");
          //console.log(this.epData.datatoday);          
          this.oEPToday = this.epData.datatoday;   
          this.initMap();
        });    
    
  }    
  doSearch(){
      Promise.all([    
          this.ueData.getUEToday(),            
        ]).then(data => {
          if(this.ueData.uetoday){
            this.strUECount = this.ueData.uetoday.length.toString();    
          }
          else{
            this.strUECount = "0";
          }
        });
  }
  onStartKont(){
    this.navCtrl.push(PPListPage,{ title: 'Kontrolle starten', icon: 'add', viewmode:'createue' });    
  }
  onShowMessage(){
    this.navCtrl.push(NotificationListPage,{ title: 'Nachrichten', icon: 'mail'});    
    
  }

  // Present an alert with the current username populated
  // clicking OK will update the username and display it
  // clicking Cancel will close the alert and do nothing


  logout() {
    this.userData.logout();
    this.navCtrl.setRoot(LoginPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/account/account-home.ts